import { el, VNode } from "@dhx/ts-common/dom";
import { IBaseShape, IOrgCardConfig } from "@dhx/ts-diagram";
import { BaseShape } from "./BaseShape";
import { getCircleTpl, getHeaderTpl, getTextTemplate } from "../templates/templates";
import { getMeta } from "../../helpers/baseMetaInfo";
import locale from "../../locales/en";

export class Card extends BaseShape implements IBaseShape {
	public config: IOrgCardConfig;

	constructor(config: IOrgCardConfig, parameters?) {
		super(config, parameters);
	}
	public getMetaInfo(): { [key: string]: string }[] {
		return getMeta([
			{ type: "grid", label: locale.gridStep },
			{ type: "color", label: locale.color },
			{ type: "position", label: locale.position },
			{ type: "size", label: locale.size },
			{ type: "text", label: locale.text },
		]);
	}
	public render(): VNode {
		const { id, angle, width, height, headerColor, $group, $selected } = this.config;
		const zIndex = $group || $selected ? ($selected ? 2 : 1) : 0;
		const borderColor = this.config.$selected ? headerColor : "#E4E4E4";
		const coords = this.getCoords(this.config);

		const circle = [];
		if (Array.isArray(this.config.dir)) {
			this.config.dir.forEach((_dir, index) => {
				circle.push(getCircleTpl(this.config, index));
			});
		} else {
			circle.push(getCircleTpl(this.config));
		}

		return el(
			"div",
			{
				_key: id,
				dhx_id: id,
				class: "dhx_diagram_item dhx_diagram_shape " + this.getCss(),
				style: {
					transform: `rotate(${angle || 0}deg)`,
					position: "absolute",
					top: coords.y,
					left: coords.x,
					zIndex,
				},
			},
			[
				el("div", {
					class: "dhx_item_shape",
					id,
					style: {
						height,
						width,
						border: `1px solid ${borderColor}`,
						borderRadius: "1px",
					},
				}),
				getHeaderTpl(this.config),
				getTextTemplate(this.config, this.getContent()),
				...circle,
			]
		);
	}
	protected setDefaults(config: IOrgCardConfig, defaults?: IOrgCardConfig): IOrgCardConfig {
		const { width, height, text, headerColor, fixed } = config;

		const widthDefaut = defaults.width ? parseFloat(defaults.width as any) : 140;
		const heightDefault = defaults.height ? parseFloat(defaults.height as any) : 90;

		config.width = width || widthDefaut;
		config.height = height || heightDefault;
		config.text = typeof text === "string" ? text : defaults.text || "";
		config.headerColor = headerColor || defaults.headerColor || "";

		config.fixed = fixed || false;
		config.editable = typeof config.editable === "boolean" ? config.editable : true;

		return config;
	}
	protected getContent(): any {
		const { $editable, text } = this.config;
		return el("span.dhx_diagram_item__text", $editable ? [this.getEditorNode()] : text);
	}
}
